import React from 'react';
import PropTypes from 'prop-types';
import toastr from 'toastr';
import Validator from '../../shared/validator';
import Loading from '../../shared/loading';
import parseFailXhr from '../../shared/parse-fail-xhr';
import { setInvestorType } from '../../services/onboarding-services';

const triggerDianomiTracker = () => {
  // LPH-293
  $.get('https://www.dianomi.com/pixeltrack.pl?c=4139');
};

export default class OnboardingSelectInvestorTypeModal extends React.Component {
  static propTypes = {
    active: PropTypes.bool.isRequired,
    onComplete: PropTypes.func.isRequired,
    investorTypes: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.string.isRequired,
      id: PropTypes.number.isRequired,
    })).isRequired,
    currentStepIndex: PropTypes.number.isRequired,
    totalStepCount: PropTypes.number.isRequired,
  }

  constructor(props, context) {
    super(props, context);

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleInvestorTypeChanged = this.handleInvestorTypeChanged.bind(this);

    this.state = {
      investorTypeId: null,
      userAttemptedToDismiss: false,
      validator: new Validator({
        investorTypeIdRequired: state => !!state.investorTypeId,
        userDidNotAttemptToDismiss: state => !state.userAttemptedToDismiss,
      }),
    };
  }

  componentDidMount() {
    if (this.props.active) {
      this.$modal.show();
      triggerDianomiTracker();
    }

    const self = this;
    this.$modal.click(function onClick(e) {
      if (e.target === this) {
        self.setState(state => {
          state.userAttemptedToDismiss = true;
          state.validator.validateForm(state);
        });
      }
    });
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.active && this.props.active) {
      this.$modal.fadeIn(800);
      triggerDianomiTracker();
    }
  }

  handleSubmit(event) {
    event.preventDefault();

    this.setState(
      state => {
        state.userAttemptedToDismiss = false;
        state.validator.validateForm(state);

        return state;
      },
      () => {
        if (!this.state.validator.formValid) return;

        this.loading.start();

        setInvestorType(this.state.investorTypeId).then(() => {
          this.$modal.fadeOut(800, () => this.loading.stop());
          this.props.onComplete();
        }).catch(err => {
          this.loading.stop();
          const errors = parseFailXhr(err.jqXHR);
          errors.anyUnhandledErrors() && toastr.error(errors.getErrorSummary(), 'Error');
        });
      },
    );
  }

  handleInvestorTypeChanged(event) {
    const investorTypeId = event.target.value;

    this.setState(state => {
      state.userAttemptedToDismiss = false;
      state.investorTypeId = investorTypeId;
      state.validator.validateInvestorTypeIdRequired(state);

      return state;
    });
  }

  render() {
    const isInvalid = this.state.validator.userDidNotAttemptToDismissValid
      && this.state.validator.investorTypeIdRequiredValid;
    return (
      <div
        ref={e => (this.$modal = $(e))}
        className="livewire-modal onboarding-select-investor-type-modal"
        tabIndex="-1"
        role="dialog"
      >
        <article>
          <header>
            {this.props.totalStepCount <= 1 || this.props.currentStepIndex === -1 || (
              <p className="step">
                {`Step ${this.props.currentStepIndex + 1} of ${this.props.totalStepCount}`}
              </p>
            )}
            <h4>What type of investor are you?</h4>
          </header>
          <section>
            <p className="step-instructions">
              Select the investor type which best describes you.
            </p>
            <form onSubmit={this.handleSubmit}>
              <Loading ref={e => (this.loading = e)} variant="small">
                <React.Fragment>
                  <div className="btn-group">
                    {this.props.investorTypes.map(investorType => (
                      <label
                        htmlFor={`investor-type-${investorType.id}`}
                        className="btn btn-default"
                        key={investorType.id}
                      >
                        <input
                          id={`investor-type-${investorType.id}`}
                          type="radio"
                          name="investorType"
                          value={investorType.id}
                          autoComplete="off"
                          onChange={this.handleInvestorTypeChanged}
                        />
                        {` ${investorType.name}`}
                      </label>
                    ))}
                  </div>
                  {isInvalid || (
                    <p className="has-error">
                      <span className="help-block">Please select your investor type</span>
                    </p>
                  )}
                  <p className="form-group submit-group">
                    <button type="submit" className="btn btn-primary">Continue</button>
                  </p>
                </React.Fragment>
              </Loading>
            </form>
          </section>
        </article>
      </div>
    );
  }
}
